<app-help-page mainVideo="managing-metrics"
               [tutorials]="['metrics-management-page']"
               [videos]="['managing-metrics']"></app-help-page>
